import { Stack } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FilterSummary,
  SummaryCardNew,
  useDrawerFilter,
} from '@hapvida/hapvida-core-components';

import { UserListCardTable } from './components/UserListCardTable';
import { useUsersState } from './hooks/useUsersState';
import { userDrawerFilterValues } from '../../constants';
import { CreateUserRouter } from '../../../CreateUser/router';
import { UserListSubHeader } from './components/UserListSubHeader';

export function UserListDesktopLayout() {
  const { usersState } = useUsersState();
  const navigate = useNavigate();

  const totalUsersLength = usersState?.data ? usersState.data.total : 0;

  const filterSummaryLabel = `${totalUsersLength} ${
    totalUsersLength === 1 ? 'usuário' : 'usuários'
  }`;

  const { getInitialFilter, setActiveFilters } = useDrawerFilter();
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      const initialUsersFilters = getInitialFilter({
        filtersConfig: userDrawerFilterValues,
      });

      setActiveFilters(initialUsersFilters);
    }
  }, []);

  return (
    <>
      <UserListSubHeader />
      <Stack paddingY={3} gap={3}>
        <FilterSummary totalLabel={filterSummaryLabel} />

        <SummaryCardNew.Container>
          <SummaryCardNew.Header
            subtitle="Lista dos usuários que podem acessar a plataforma."
            title="Usuários"
            buttonProps={{
              onClick: () => navigate(CreateUserRouter.path),
              content: 'Novo usuário',
              variant: 'contained',
              color: 'success',
              sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
            }}
          />
          <UserListCardTable />
        </SummaryCardNew.Container>
      </Stack>
    </>
  );
}
